<script>
  import { format } from 'svelte-i18n';
  import { Alert, Input } from '@sveltestrap/sveltestrap';

  export let error = '';
  export let config = {};
  export let updating = false;
  export let onKeyUp = () => {};
</script>

{#if error}
  <Alert color="danger">{@html error}</Alert>
{/if}

<p>{$format('label.DOMAIN')}</p>

<Input type="text" name="domainname" bind:value={config.domainname} disabled />

<p>{$format('label.BILLING_ID')} (Maxio)</p>
<Input
  type="text"
  name="billingId"
  autoComplete="off"
  bind:value={config.billingid}
  on:keyup={onKeyUp}
  disabled={updating}
  placeholder={$format('label.PLACEHOLDER.BILLING_ID')}
/>

<p>{$format('label.BILLING_ID')} (Younium)</p>
<Input
  type="text"
  name="billingId"
  autoComplete="off"
  bind:value={config.ybillingid}
  on:keyup={onKeyUp}
  disabled={updating}
  placeholder={$format('label.PLACEHOLDER.BILLING_ID')}
/>

<p>{$format('label.AUTH_CODE')}</p>
<Input
  type="password"
  name="authcode"
  autoComplete="off"
  bind:value={config.authcode}
  disabled={updating}
  on:keyup={onKeyUp}
  placeholder={$format('label.PLACEHOLDER.AUTH_CODE')}
/>

<style lang="scss">
  p {
    margin: var(--margin-base) 0;
  }
</style>
